<app-modal [showCloseButton]="false">
  <div
    class="message"
    [class.message--info]="infoMessage"
    [class.message--error]="errorMessage"
    *ngIf="message"
  >
    <h4 class="message__title">{{message.title}}</h4>
    <div class="message__content" [innerHTML]="message.content"></div>
    <button class="message__close" (click)="onCloseButtonClick()">Close</button>
  </div>
</app-modal>



// WEBPACK FOOTER //
// ./src/app/shared/components/message/message.component.html